import React from "react";
import { connect } from "react-redux";
import { subscriptionDetailsUser } from "../../actions/userActions";
import { cancelSubscription } from "../../actions/paymentActions";
import { Spinner } from "react-bootstrap";
import history from "../../config/history";
import { InfoModal } from "../modals/InfoModal";
import { pageview } from "../../utils/googleAnalyticsUtils";

class Plan extends React.Component {
  async componentDidMount() {
    pageview('Settings-Plan');
    await this.props.subscriptionDetailsUser();
  }

  state = {
    cancelModalShow: false,
  };

  handleCloseCancelModal = () => {
    this.setState({
      cancelModalShow: false,
    });
  };

  handleShowCancelModal = () => {
    this.setState({
      cancelModalShow: true,
    });
  };

  renderNoPlan() {
    return (
      <div className="lead settings-plan-active-subscription-container">
        <p>
          You are not subscribed to any of the premium plans. To get access to
          more exclusive content
        </p>
        <button
          className="btn btn-md btn-primary"
          onClick={() => history.push("/pricing")}
        >
          Subscribe now!
        </button>
      </div>
    );
  }

  renderSubscriptionActive(subDetails) {
    return (
      <div className="lead settings-plan-active-subscription-container">
        <p>Your current plan is : {subDetails?.plan}</p>
        {!subDetails.isOneTime && <div className="settings-plan-manage-cancel-btn-container">
          <button
            className="btn btn-primary"
            onClick={() =>
              (window.location.href = subDetails?.manageSubscriptionUrl)
            }
          >
            Manage Subscription
          </button>
          {!subDetails?.isCancelled ? <button
            onClick={this.handleShowCancelModal}
            className="btn btn-danger"
          >
            Cancel Subscription
          </button> : <p>Your subscription has been cancelled, and your plan membership will be active until the end of current billing cycle.</p>}
        </div>}
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.props.subscriptonDetailesLoading ? (
          <Spinner animation="border" role="status" />
        ) : (
          <div>
            <InfoModal
              modalShow={this.state.cancelModalShow}
              onHide={this.handleCloseCancelModal}
              closeButton={true}
              actionButton={this.props.cancelSubscription}
              heading={"Cancel Subscription?"}
              bodyContent={
                "Are you sure you want to cancel your subscription? This action cannot be reversed!"
              }
              actionButtonText={"Cancel"}
            />
            {this.props?.subscriptionDetails?.hasSubscription
              ? this.renderSubscriptionActive(this.props.subscriptionDetails)
              : this.renderNoPlan()}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    subscriptionDetails: state.userAccountDetails.userSubscriptionDetails,
    subscriptonDetailesLoading: state.userAccountDetails.loading,
  };
};
export default connect(mapStateToProps, {
  subscriptionDetailsUser,
  cancelSubscription,
})(Plan);
